<template>
	<div>
		<router-view v-show="$route.matched.length == 3"></router-view>
		<div
			id="auditTop"
			class="main-page-content"
			v-show="$route.matched.length == 2"
		>
			<PageHeaderLayout>
				<el-dialog
					title="我的登记二维码"
					:visible.sync="showQrcodeDialog"
					width="520px"
					:close-on-click-modal="false"
				>
					<div class="qrcode-info">
						<div>
							<div class="code">
								<el-image
									style="width: 100%; height: 100%"
									:src="qrcodeInfo.qr_code_url"
								></el-image>
							</div>
						</div>
						<div class="desc">
							<div>
								<div class="label">企业名称</div>
								<div class="value">{{ qrcodeInfo.product_name || "--" }}</div>
							</div>
							<div>
								<div class="label">使用说明</div>
								<div class="value">
									扫描此二维码可快速登记个人信息，数据将自动同步到本系统
								</div>
							</div>
						</div>
					</div>
				</el-dialog>
				<div style="background: #fff; padding: 20px 20px">
					<div class="search-bar">
						<el-form
							:inline="true"
							:model="searchCondition"
							class="demo-form-inline"
						>
							<el-form-item label="模糊搜索">
								<el-input
									clearable
									v-model="searchCondition.recruit_post"
									placeholder="请输入搜索内容"
								></el-input>
							</el-form-item>
							<el-form-item label="时间">
								<DatePicker @dataSearch="dataSearch" />
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="searchButton">查询</el-button>
							</el-form-item>
						</el-form>
						<el-button type="primary" @click="showQrcodeDialog = true">
							生成二维码
						</el-button>
					</div>
					<div
						style="marrgin: 0 20px"
						v-loading="loading"
						element-loading-text="玩命加载中……"
						element-loading-spinner="el-icon-loading"
					>
						<el-table
							:data="tableData"
							style="width: 100%"
							:header-cell-style="{ background: '#fbfbfb' }"
						>
							<el-table-column
								v-for="(item, index) in columns"
								:key="index"
								:label="item.title"
								align="center"
							>
								<template slot-scope="scope">
									<span>{{
										item.type == "status"
											? item.propsData[scope.row[item.value]]
											: scope.row[item.value]
									}}</span>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<el-pagination
					style="float: right"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page.sync="pagege.current_page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pagege.page_size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagege.total"
				></el-pagination>
			</PageHeaderLayout>
		</div>
	</div>
</template>

<script>
import DatePicker from "@/components/DatePicker.vue";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import UploadImg from "@/components/uploadImg/index.vue";
export default {
	components: {
		DatePicker,
		PageHeaderLayout,
		UploadImg,
	},
	data() {
		var checkName = (rule, value, callback) => {
			if (value === "") {
				callback(new Error("请输入失败原因!"));
			} else {
				callback();
			}
		};
		return {
			qrcodeInfo: {},
			columns: [
				{
					title: "任务名称",
					value: "job_name",
					width: 200,
					align: "center",
				},
				{
					title: "姓名",
					width: 100,
					align: "center",
					value: "user_name",
				},
				{
					title: "性别",
					type: "status",
					width: 200,
					align: "center",
					value: "gender",
					propsData: {
						MALE: "男",
						FEMALE: "女",
					},
				},
				{
					title: "手机号",
					width: 200,
					align: "center",
					value: "phone_number",
				},
				{
					title: "实名认证",
					width: 200,
					align: "center",
					value: "certified",
					type: "status",
					propsData: {
						0: "否",
						1: "是",
					},
				},
				{
					title: "人脸核实",
					width: 200,
					align: "center",
					value: "face_auth_status",
					type: "status",
					propsData: {
						0: "否",
						1: "是",
					},
				},
				{
					title: "健康证",
					width: 200,
					align: "center",
					value: "health_cert",
				},
				{
					title: "社会风险信息",
					width: 200,
					align: "center",
					value: "social_risk_info",
					type: "status",
					propsData: {
						0: "否",
						1: "是",
					},
				},
				{
					title: "扫码时间",
					width: 200,
					align: "center",
					value: "register_time",
				},
			],
			searchCondition: {},
			pagege: {},
			id: "",
			loading: false,
			radio: 1,
			tableData: [],
			ispage: 1,
			num: 10,
			userRules: {
				textarea: [{ required: true, validator: checkName, trigger: "blur" }],
			},
			showQrcodeDialog: false,
			uploadDialog: {
				show: false,
				form: {
					deliver_content: "",
					deliver_images: [],
				},
				data: {},
			},
		};
	},
	created() {
		this.init();
		this.getCode();
	},

	methods: {
		// 搜索
		searchButton() {
			this.init();
		},
		//获取选中日期的值
		dataSearch(value) {
			console.log(value);
			this.searchCondition.time = {};
			this.searchCondition.time.start_time = value[0];
			this.searchCondition.time.end_time = value[1];
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.num = val;
			this.ispage = 1;
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.ispage = val;
			this.init();
		},
		async getCode() {
			this.loading = true;
			let res = await this.$api.get_anxinCode_qrcode();
			this.qrcodeInfo = res;
		},
		async init() {
			let objects = {
				current_page: this.ispage,
				page_size: this.num,
			};
			let res = {};
			this.loading = true;
			res = await this.$api.get_anxinCode_personalList({
				...objects,
			});
			let { list, pages } = res;

			this.tableData = list;
			this.pagege = pages;
			this.loading = false;
		},
	},
};
</script>

<style scoped lang="scss">
.main-page-content {
	padding-bottom: 50px;
}
.qrcode-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px;
	margin-bottom: 16px;
	background: #fff;
	border-radius: 4px;
	.title {
		font-size: 18px;
		color: #2b2b2b;
		font-weight: 500;
		margin-bottom: 6px;
	}
	.value {
		color: #606266;
	}
}
.qrcode-info {
	display: flex;
	align-items: flex-start;
	.code {
		width: 200px;
		height: auto;
	}
	.desc {
		margin-left: 16px;
		margin-top: 10px;
		& > div {
			margin-bottom: 20px;
			.label {
				font-size: 16px;
				margin-bottom: 10px;
				color: #2b2b2b;
			}
		}
	}
}
.search-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>
